import { LoginService } from "./login.service";
import ArrayToTree from "array-to-tree";
import { message } from "ant-design-vue";
import { notifyEmitter } from "@/utils/emitter";
import { computed, reactive } from "vue";
import { clearCookies } from "@/utils";
import Storage from "@/core/services/storage";
let lockr = new Storage("cpms_");
import { TABS_ROUTES, CACHED_TABS_ROUTES } from "@/core/constant";
import store from "@/store";
import router from '@/core/router'

//递归获取一级菜单
const getMenuByRecursion = (arr, path, menuId) => {
  let obj;
  if (path) {
    obj = arr.find((o) => o.path === path);
  } else {
    obj = arr.find((o) => o.menuId === menuId);
  }
  if (obj && obj.parentId !== "0") {
    obj = getMenuByRecursion(arr, null, obj.parentId);
  }
  return obj;
};

export const getMenus = async (route, fromLoginPage) => {
  // debugger
  const { run: runInit } = LoginService.clearInitStatus();
  let permissMap: any = [];
  const state:any = reactive({
    userInfo: computed(() => store.state.user.userInfoAccessToken),
  });
  const belongSystem = store.state.user.belongSystem
  if (!(state.userInfo?.permissions?.length>0)) {
    const { run: runUserInfo } = LoginService.useUserInfoApi(true);
    
    const result = await runUserInfo(belongSystem);
    if (result.respCode === "0000") {
      await runInit();
    } else if(result.respCode === '0024'){
      message.error(result.respDesc)
      setTimeout(function(){
        lockr.flush();
        clearCookies();
        store.commit("user/SET_INFO", {});
        window.location.href = "/login";
        localStorage.removeItem(TABS_ROUTES);
        localStorage.removeItem(CACHED_TABS_ROUTES);
      },2000);
      return;
    }else{
      return;
    }
  }
  //@ts-ignore
  let flg = state.userInfo?.permissions?.length > 0;
  if (!flg) {
    message.error("暂无任何菜单权限，请联系管理员");
    return;
  }
  //@ts-ignore
  const records = state.userInfo?.permissions.reduce((pre: any, o: any) => {
    let tmp = {
      menuId: o.menuId,
      menuName: o.menuName,
      parentId: o.parentId,
      path: o.path,
      pcIcon: o.pcIcon,
      example: o.example,
      sort: o.sort,
      isHideRouter: o.isHideRouter,
    };
    if (o.type === "menu") {
      pre.push(tmp);
    }
    return pre;
  }, []);
  // console.log("records=====================================", records);
  //@ts-ignore
  const buttons = state.userInfo?.permissions.reduce((pre: any, o: any) => {
    let tmp = {
      menuId: o.menuId,
      menuName: o.menuName,
      parentId: o.parentId,
      path: o.path,
      pcIcon: o.pcIcon,
      isHideRouter: o.isHideRouter,
      sort: o.sort,
    };
    pre[o.path] = tmp;
    return pre;
  }, {});
  //通过判断vipLevel是否等于-1，-1的话员工资料那里就能新增员工，否则不就能新增员工
  //@ts-ignore
  let canAddUserFlag = state.userInfo?.tenantDetailResp.vipLevel === "-1";
  store.commit("user/SET_CANADDUSER", canAddUserFlag);
  //选中的一级菜单
  let first = records.find((o: any) => o.parentId === "0" && o.menuName === "工作台");
  if (!first) {
    //不存在工作台，则根据当前路由获取一级菜单
    first = getMenuByRecursion(records, route.fullPath, null);
    if (!first) {
      first = records.find((o) => o.parentId === "0");
    }
  }

  //键值对菜单
  const _originalMenuObj = {};
  records.forEach((o: any) => {
    _originalMenuObj[o.path] = o;
  });

  permissMap = ArrayToTree(records, {
    parentProperty: "parentId",
    customID: "menuId",
  });
  let parentChildrenObj = {};
  permissMap.forEach((o) => {

    try {
      let firstParent = o;
      if (o.children?.length) {
        o.children.forEach((ii) => {
          let secondParent = ii;
          if (ii?.children?.length) {
            ii.children.forEach((m) => {
              _originalMenuObj[m.path].firstParent = firstParent;
              _originalMenuObj[m.path].secondParent = secondParent;
              // 三级菜单处理
              if(m?.children?.length){
                m?.children.forEach((s) => {
                  _originalMenuObj[s.path].firstParent = firstParent;
                  _originalMenuObj[s.path].secondParent = secondParent;
                })
              }
            });
          } else {
            _originalMenuObj[ii.path].firstParent = firstParent;
          }
        });
      }
      parentChildrenObj[o.menuId] = o.children;
    } catch (error) {
      console.log(error);
    }
  });
  let tmp = {};
  Object.keys(_originalMenuObj).forEach((o) => {
    if (_originalMenuObj[o].parentId === "0") {
      tmp[o] = _originalMenuObj[o];
    }
  });
  // console.log("parentChildrenObj-----------------------", parentChildrenObj);
  for (let key in parentChildrenObj) {
    let arr = parentChildrenObj[key];
    if (!arr) {
      continue;
    }
    arr.forEach((o) => {
      if (o.children) {
        o.children.sort((a, b) => {
          if (a.sort > b.sort) {
            return -1;
          } else if (a.sort < b.sort) {
            return 1;
          } else {
            return 0;
          }
        });
        o.children.forEach((i) => {
          if (i.children) {
            i.children.sort((a, b) => {
              if (a.sort > b.sort) {
                return -1;
              } else if (a.sort < b.sort) {
                return 1;
              } else {
                return 0;
              }
            });
          }
        });
      }
    });
    arr.sort((a, b) => {
    if (a.sort > b.sort) {
      return -1;
    } else if (a.sort < b.sort) {
      return 1;
    } else {
      return 0;
    }
  });
  }
  store.commit("user/SET_originalMenuObj", _originalMenuObj);
  store.commit("user/SET_parentChildrenObj", parentChildrenObj);
  store.commit("user/SET_PERMISSIONS", permissMap);
  store.commit("user/SET_BUTTONS", buttons);
  console.log(permissMap, "permissMap");
  permissMap.sort((a, b) => {
    if (a.sort > b.sort) {
      return -1;
    } else if (a.sort < b.sort) {
      return 1;
    } else {
      return 0;
    }
  });
  //  if(belongSystem==2) {
    await store.dispatch('user/GET_AUTHSTATUS')
  // }
  // permissMap.forEach(o=>{
  //   if(o.children){
  //     o.children.sort((a,b)=>{
  //       if(a.sort>b.sort){
  //         return -1
  //       }else if(a.sort<b.sort){
  //         return 1
  //       }else{
  //         return 0
  //       }
  //     })
  //     o.children.forEach(i=>{
  //       if(i.children){
  //         i.children.sort((a,b)=>{
  //           if(a.sort>b.sort){
  //             return -1
  //           }else if(a.sort<b.sort){
  //             return 1
  //           }else{
  //             return 0
  //           }
  //         })
  //       }
  //     })
  //   }
  // })
  //@ts-ignore
  if (state.userInfo?.permissions.length == 0) {
    message.error("暂无任何菜单权限，请联系管理员分配权限");
  } else {
    //选中的二级菜单
    let tmp = permissMap.find((p) => p.menuId === first.menuId);
    let second = records.find((o: any) => o.parentId === (tmp as any)?.menuId);
    if (tmp.children?.length) {
      let t = records.find((o: any) => o.parentId === (tmp.children[0] as any)?.menuId);
      //由于工作台没有层级结构，这里给工作台做特殊处理
      if (t) {
        second = t;
      }
    }
    // console.log("first", first);
    // console.log("second", second,'fromLoginPage',fromLoginPage);
    // 是否是从登陆页面过来的，登陆页面过来的要跳转到工作台去
    //如果是刷新当前页面，则不走一下逻辑
    if (fromLoginPage && second) {
      store.commit("user/SET_leftMenus", parentChildrenObj[(first as any)?.menuId]);
      if ((second as any).children && (second as any).children.length > 0) {
        await router.replace(`${(second as any)["children"][0]["path"]}`);
      } else {
        // console.log("ddddddddddd", `${(second as any)["path"]}`);
        await router.replace(`${(second as any)["path"]}`);
      }
    } else {
      console.log("fromLoginPage", fromLoginPage, "second", second);
    }
  }
  // } else {
  //   notifyEmitter.emit(
  //     "user-outdate",
  //     "您的合伙人1号租户账号已过期，现在续费立刻获得完整版工程企业管理系统。"
  //   );
  // }
};

export const getMenusAndNoJump = async (store, router, route, fromLoginPage) => {
  const { run: runInit } = LoginService.clearInitStatus();
  let permissMap: any = [];
  const state = reactive({
    userInfo: computed(() => store.state.user.userInfoAccessToken),
  });
  if (!(state.userInfo?.permissions?.length>0)) {
    const { run: runUserInfo } = LoginService.useUserInfoApi(true);
    const result = await runUserInfo();
    if (result.respCode === "0000") {
      await runInit();
    } else if(result.respCode === '0024'){
      // message.error(result.respDesc)
      // setTimeout(function(){
      //   lockr.flush();
      //   clearCookies();
      //   store.commit("user/SET_INFO", {});
      //   window.location.href = "/login";
      //   localStorage.removeItem(TABS_ROUTES);
      //   localStorage.removeItem(CACHED_TABS_ROUTES);
      // },2000);
      return;
    }else{
      return;
    }
  }
  //@ts-ignore
  let flg = state.userInfo?.permissions?.length > 0;
  if (!flg) {
    message.error("暂无任何菜单权限，请联系管理员");
    return;
  }
  //@ts-ignore
  const records = state.userInfo?.permissions.reduce((pre: any, o: any) => {
    let tmp = {
      menuId: o.menuId,
      menuName: o.menuName,
      parentId: o.parentId,
      path: o.path,
      pcIcon: o.pcIcon,
      example: o.example,
      sort: o.sort,
      isHideRouter: o.isHideRouter,
    };
    if (o.type === "menu") {
      pre.push(tmp);
    }
    return pre;
  }, []);

  //键值对菜单
  const _originalMenuObj = {};
  records.forEach((o: any) => {
    _originalMenuObj[o.path] = o;
  });

  permissMap = ArrayToTree(records, {
    parentProperty: "parentId",
    customID: "menuId",
  });
  let parentChildrenObj = {};
  permissMap.forEach((o) => {

    try {
      let firstParent = o;
      if (o.children?.length) {
        o.children.forEach((ii) => {
          let secondParent = ii;
          if (ii?.children?.length) {
            ii.children.forEach((m) => {
              _originalMenuObj[m.path].firstParent = firstParent;
              _originalMenuObj[m.path].secondParent = secondParent;
              // 三级菜单处理
              if(m?.children?.length){
                m?.children.forEach((s) => {
                  _originalMenuObj[s.path].firstParent = firstParent;
                  _originalMenuObj[s.path].secondParent = secondParent;
                })
              }
            });
          } else {
            _originalMenuObj[ii.path].firstParent = firstParent;
          }
        });
      }
      parentChildrenObj[o.menuId] = o.children;
    } catch (error) {
      console.log(error);
    }
  });
  store.commit("user/SET_originalMenuObj", _originalMenuObj);
  return _originalMenuObj
};